import { fork, all } from 'lib/redux';
import cancelOrder from 'features/cancel-order-dialog/CancelOrder.watcher';
import sitemap from 'features/sitemap/Sitemap.watcher';
import dashboard from 'features/dashboard/Dashboard.watcher';
import orderPreferences from 'features/orderPreferences/OrderPreferences.watcher';
import uploadInformation from 'features/uploadInformation/UploadInformation.watcher';
import managePaymentOptions from 'features/managePaymentOptions/ManagePaymentOptions.watcher';
import analyticsDashboard from 'features/analyticsDashboard/AnalyticsDashboard.watcher';
import reportsChange from 'features/reportTypeChange/ReportsChange.watcher';
import order from '../features/order/Order.watcher';
import finalizeOrder from '../features/finalizeOrder/FinalizeOrder.watcher';
import orderHistory from '../features/orderHistory/OrderHistory.watcher';
import userData from '../features/userData/UserData.watcher';
import userEntitlements from '../features/user-entitlements/UserEntitlements.watcher';
import reportDetailsPage from '../features/reportDetails/ReportDetailsPage.watcher';
import addressVerification from '../features/addressVerification/AddressVerification.watcher';
import pitchEditor from '../features/pitchEditor/PitchEditor.watcher';
import accountsDeletion from '../features/accountsDeletion/AccountsDeletion.watcher';
import billingInformation from '../features/billingInfomation/BillingInformation.watcher';
import contactInformation from '../features/contactInformation/ContactInformation.watcher';
import textAlertSettings from '../features/textAlertSettings/TextAlertSettings.watcher';
import srs from '../features/order/components/SRS/SRS.watcher';
/**
 * Root Saga that forks all the watchers
 */
export default function* startForman() {
  yield all([
    fork(order),
    fork(finalizeOrder),
    fork(orderHistory),
    fork(userData),
    fork(userEntitlements),
    fork(cancelOrder),
    fork(sitemap),
    fork(reportDetailsPage),
    fork(addressVerification),
    fork(pitchEditor),
    fork(dashboard),
    fork(orderPreferences),
    fork(accountsDeletion),
    fork(billingInformation),
    fork(contactInformation),
    fork(uploadInformation),
    fork(textAlertSettings),
    fork(srs),
    fork(managePaymentOptions),
    fork(analyticsDashboard),
    fork(reportsChange),
  ]);
}
